import {fromJS} from 'immutable';
import * as types from 'constants/action-types';

const initialState = fromJS({
  msgType: null,
  message: '',
});

const addFlashMessageReducer = (state, action) =>
  fromJS({
    msgType: action.msgType,
    message: action.message || '',
  });

const clearFlashMessageReducer = () => initialState;

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    case types.ADD_FLASH_MESSAGE:
      return addFlashMessageReducer(state, action);
    case types.CLEAR_FLASH_MESSAGE:
      return clearFlashMessageReducer(state, action);
    default:
      return state;
  }
};
